import Consts from "../../consts/clientConsts";

export default class {
    Id = null;

    TradePointId = null;

    Type = null;

    Name = null;

    Phone = null;

    mapFromDto(dto) {
        if(!dto)
            return this;

        this.Id = dto.Id;
        this.TradePointId = dto.TradePointId;
        this.Type = Consts.UserRights.find(e => e.Id == dto.Type);
        this.Name = dto.Name;
        this.Phone = dto.Phone;

        return this;
    }
}